import request from './request'

export default {
  /**
   * 获取签到模版
   */
  getTemplate(param) {
    return request.get('/template', param)
  },
  /**
   * 查看签到状态
   */
  getState(param) {
    return request.get('/check', param)
  },
  /**
   * 点击签到
   */
  register(param) {
    return request.post('/register', param)
  },
  /**
   * 发奖重试接口
   */
  retryLottery(param) {
    return request.post('/retryLottery', param)
  },
  // /**
  //  * 组建队伍
  //  */
  // postFormTeam() {
  //   return request.post('/teams')
  // },

}
